<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
				<h5>Motivo de Afastamentos</h5>
                <hr>

				<Toolbar class="p-mb-4">
					<template slot="left">						
						<Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="novo" v-if="permissaoNovo"/>						
					</template>
				</Toolbar>

				<DataTable :value="motivoAfastamentos" :filters="filtro" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,20,30,50]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">
					<template #header>
						<div class="table-header">			
							<div class="p-d-flex p-jc-end">				
								<span class="p-input-icon-left">
									<i class="pi pi-search" />
									<InputText v-model="filtro['global']" placeholder="Filtrar..." />
								</span>
							</div>
						</div>
					</template>
					<Column field="descricao" header="Descrição" sortable></Column>
					<Column field="definitivo" header="Definitivo" sortable>
						<template #body="slotProps">
							{{ slotProps.data.definitivo ? 'Sim' : 'Não' }}
						</template>
					</Column>				
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)" v-if="permissaoEditar"/>
							<Button icon="pi pi-trash" title="Excluir" class="p-button-rounded p-button-danger" @click="confirmarExcluir(slotProps.data)" v-if="permissaoExcluir"/>
						</template>
					</Column>
				</DataTable>	

				<Dialog :visible.sync="exibirDialogCadastro" :header="tituloModal" :modal="true" class="p-fluid" :style="{width: '500px'}">			
					<div class="p-fluid p-formgrid p-grid">
						<div class="p-field p-col-12 p-md-12">
							<label for="descricao">Descrição</label>
							<InputText id="descricao" v-model.trim="motivoAfastamentoSelecionado.descricao" required="true" autocomplete="off"/>
							<small class="p-invalid" v-if="enviandoForm && !motivoAfastamentoSelecionado.descricao">Informe a Descrição</small>
						</div>					
					</div>	
					<div class="p-field-checkbox" v-if="!motivoAfastamentoSelecionado.id">
						<Checkbox id="definitivo" v-model="motivoAfastamentoSelecionado.definitivo" :binary="true" />
						<label for="defintivo">Definitivo</label>
					</div>	
					<div class="p-fluid p-formgrid p-grid" v-else>
						<div class="p-field p-col-12 p-md-12">
							<label for="descricao">Definitivo: <strong>{{ motivoAfastamentoSelecionado.definitivo ? 'Sim' : 'Não' }}</strong></label>							
						</div>					
					</div>		
					<template #footer>
						<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
						<Button label="Salvar" icon="pi pi-check" @click="salvar"/>
					</template>
				</Dialog>

				<Dialog :visible.sync="exibirDialogConfirmarExcluir" header="Confirmar" :modal="true" :style="{width: '450px'}">
					<div class="confirmation-content">
						<i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem; color:red" />
						<span>Excluir motivo de afastamento <b>{{ motivoAfastamentoSelecionado.descricao }}</b>?</span>
					</div>
					<template #footer>
						<Button label="Não" icon="pi pi-times" class="p-button-secondary" @click="limparExcluir"/>
						<Button label="Sim" icon="pi pi-check" class="p-button-danger" @click="excluir" />
					</template>
				</Dialog>		

			</div>
		</div>
	</div>
</template>

<script>
import MotivoAfastamentoService from '@/service/MotivoAfastamentoService';
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';
export default {
	motivoAfastamentoService: null,
	data() {
		return {
			permissaoNovo: false,
			permissaoEditar: false,
			permissaoExcluir: false,
			tituloModal: 'Novo Motivo de Afastamento',
			exibirDialogConfirmarExcluir: false,
			exibirDialogCadastro: false,		
			enviandoForm: false,
			motivoAfastamentoSelecionado: { descricao:'', definitivo: false },
			motivoAfastamentos: [],		
			filtro: {}
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),
		listar() {					
			this.motivoAfastamentoService.listar({...this.getDadosRequisicao()})
				.then(resp => {
					this.motivoAfastamentos = resp.data;
                })
                .catch(erro => {exibirMensagem(this, erro)});   
		},
		novo() {		
			this.tituloModal = 'Novo Motivo de Afastamento';	
			this.motivoAfastamentoSelecionado = { descricao:'', definitivo: false  };
			this.exibirDialogCadastro = true;
			this.enviandoForm = false;
		},
		salvar() {
			this.enviandoForm = true;
			if(this.motivoAfastamentoSelecionado.descricao != '') {
				let requisicao = {
					motivoAfastamento: {...this.motivoAfastamentoSelecionado},
					usuarioRequisicao: {...this.getDadosRequisicao()}
				}			
				this.motivoAfastamentoService.salvar(requisicao)
					.then(resp => {	
						this.fecharModal();
						this.listar();
						exibirMensagem(this, resp);						
					})
					.catch(erro => {exibirMensagem(this, erro)});
			}

		},		
		excluir() {
			let requisicao = {
				motivoAfastamento: {...this.motivoAfastamentoSelecionado},
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}			
			this.motivoAfastamentoService.excluir(requisicao)
				.then(resp => {	
					this.limparExcluir();
					this.listar();
					exibirMensagem(this, resp);						
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},
		editar(motivoAfastamento) {
			this.enviandoForm = false;
			let requisicao = {
				idMotivo: motivoAfastamento.id,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}	
			this.motivoAfastamentoService.buscar(requisicao)
				.then(resp => {	
					this.tituloModal = 'Editar motivo de afastamento';
					this.motivoAfastamentoSelecionado = resp.data;
					this.exibirDialogCadastro = true;				
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},
		confirmarExcluir(motivoAfastamento) {
			this.motivoAfastamentoSelecionado = motivoAfastamento;
			this.exibirDialogConfirmarExcluir = true;
		},
		limparExcluir() {
			this.motivoAfastamentoSelecionado = {descricao:'', definitivo:false};
			this.exibirDialogConfirmarExcluir = false;
		},
		fecharModal() {
			this.motivoAfastamentoSelecionado = {descricao:'', definitivo:false};
			this.exibirDialogCadastro = false;
			this.enviandoForm = false;
		},
		validarPermissoes() {		
			let permissoes = this.getPermissoes();
			this.permissaoNovo = permissoes.includes(20);
			this.permissaoEditar = permissoes.includes(21);
			this.permissaoExcluir = permissoes.includes(22);			
		}
	},
	created() {
		this.motivoAfastamentoService = new MotivoAfastamentoService();		
	},
	mounted() {	
		this.validarPermissoes();	
		this.listar();
	}
}
</script>

<style scoped>
</style>